<template>
	<div class="view not-found" :style="{animation: !$loaded ? 'bottomElation 0.5s 1s both' : 'bottomElation 0.5s both'}">
		<h1 class="not-found-title">Strona nie istnieje!</h1>
	</div>
</template>

<script>
	export default {
		name: "NotFound",
		data() {
			return {
				prevRoute: null
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.prevRoute = from
			})
		},
	}
</script>

<style lang="scss" scoped>
	.not-found {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.not-found-title {
			font-size: 30px;
			@include line;
		}
	}
</style>